import { showSetPasswordModal } from '../../../actions/userActions';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router';

/**
 * Enables us to have a URL that triggers the set password dialog
 * so we can trigger this easily from outside react
 */
const SetPasswordRedirect = ({ showSetPasswordModal }) => {
  useEffect(() => {
    // Passing in true tells the modal to show a close button
    showSetPasswordModal(true);
  }, [showSetPasswordModal]);

  return <Navigate to="/" />;
};

const mapDispatchToProps = {
  showSetPasswordModal,
};

export default connect(null, mapDispatchToProps)(SetPasswordRedirect);
